import { Card, Row, Col, Button, Form } from 'react-bootstrap';

const NotificationsTab = () => {

    const handleSubmitForm = (e) => {
    }

    return (
        <Row className='ml-3'>
            <Col xl={6} >
                <Form onSubmit={handleSubmitForm}>
                    <Card>
                        <Card.Header className="py-2 d-flex" >
                            <Card.Title>
                                <span className='text-muted text-s m-0 p-0'>Notifications</span>
                            </Card.Title>
                        </Card.Header>
                        <Card.Body className='d-flex flex-column'>
                            <span className='text-muted text-sm mb-3 font-italic'>A quelles occasions souhaitez vous recevoir un email?</span>
                            <Form.Check type="checkbox" id="creationTicket" label="Création de ticket" />
                            <Form.Check type="checkbox" id="interventionTicket" label="Intervention" />
                            <Form.Check type="checkbox" id="clotureTicket" label="Clôture de ticket" />
                            <Form.Check type="checkbox" id="ouvertureTicket" label="Ouverture de ticket" />
                            <Button variant="primary" type="submit" className="mt-3">Sauvegarder les changements</Button>
                        </Card.Body>
                    </Card>
                </Form>
            </Col>
        </Row>
    );
};

export default NotificationsTab